import styled from 'styled-components'

import Icon from 'components/Icon.v2'

export const VendorHeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 78px;

  padding: 0 15px;
  border-top: 3px solid ${props => props.theme.colors.whitelabel};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const InfoSection = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const VenueName = styled.h1`
  margin: 2px 0;
  font-size: 16px;
  font-weight: 500;
`

export const Tags = styled.section`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`

export const TagsSeparator = styled.b`
  font-size: 1.25em;
  padding: 0 3px;
`

export const HeaderIcon = styled(Icon)`
  cursor: pointer;
`
